export const NO_TASK_OPTION = {
  id: 'no-task',
  isNoTask: true
};

export const SHOW_INACTIVE_PROJECTS_OPTION_ID = 'show-inactive-projects';
export const SHOW_CLOSED_TASKS_OPTION_ID = 'show-closed-tasks';

export const MOVE_TIME_STEP_KEYS = {
  SELECTION: 'selectionStep',
  DESTINATION: 'destinationStep',
  PROGRESS: 'progressStep',
  RESULT: 'resultStep'
};

export const MOVE_TIME_STEPS = [
  {
    key: MOVE_TIME_STEP_KEYS.SELECTION,
    labelId: 'moveTimeDialog.selectTimeToMove'
  },
  {
    key: MOVE_TIME_STEP_KEYS.DESTINATION,
    labelId: 'moveTimeDialog.chooseWhereToMove'
  },
  { key: MOVE_TIME_STEP_KEYS.PROGRESS, labelId: 'moveTimeDialog.progress' },
  { key: MOVE_TIME_STEP_KEYS.RESULT, labelId: 'moveTimeDialog.result' }
];

export const MOVE_TIME_STEP_INDICES = {
  SELECTION: 0,
  DESTINATION: 1,
  PROGRESS: 2,
  RESULT: 3
};

export const INITIAL_MOVE_TIME_DATA = {
  source: {
    project: null,
    task: null,
    filter: {
      showInactiveProjects: false,
      showClosedTasks: false
    }
  },
  destination: {
    project: null,
    task: null,
    filter: {
      showInactiveProjects: false,
      showClosedTasks: false
    }
  },
  billingStatus: null,
  criteria: []
};

export const BILLING_TYPE = {
  FIXED_BID: 'urn:replicon:billing-type:fixed-bid',
  TIME_AND_MATERIAL: 'urn:replicon:billing-type:time-and-material',
  NON_BILLABLE: 'urn:replicon:billing-type:non-billable',
  BILLING_CONTRACT: 'urn:replicon:billing-type:billing-contract'
};

export const BILLING_STATUS_VALUES = {
  NO_CHANGE: 'noChange'
};
